import JNetworkList from './JNetworkList'

/* istanbul ignore next */
JNetworkList.install = function (Vue) {
  Vue.component(JNetworkList.name, JNetworkList)
}

export default JNetworkList
